import { ApolloClient } from 'apollo-client'
import { split } from 'apollo-link'
// import { HttpLink } from 'apollo-link-http'
import { WebSocketLink } from 'apollo-link-ws'
import { SubscriptionClient } from 'subscriptions-transport-ws'
import { getMainDefinition, toIdValue } from 'apollo-utilities'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloLink, concat } from 'apollo-link'
import { createUploadLink } from 'apollo-upload-client'
// import { RetryLink } from 'apollo-link-retry'

import AuthStore from './pages/Auth/store'

// const CAN_OFFLINE = JSON.parse(process.env.REACT_APP_CAN_OFFLINE)

// attached extra headers when requesting through graphql
const request = new ApolloLink((operation, forward) => {
	let headers = {}
	let token = AuthStore.token

	if (token) {
		headers.Authorization = `Bearer ${token}`
		headers.ServerSerialNumber = process.env.REACT_APP_SERVER_SERIAL_NUMBER
	} else {
		headers.ByPassToken = '@ullenP0Gi1989'
		headers.ServerSerialNumber = process.env.REACT_APP_SERVER_SERIAL_NUMBER
	}

	// add the authorization to the headers
	operation.setContext({ headers })

	return forward(operation)
})

// target graphql endpoint
const uploadLink = createUploadLink({
	uri: (AuthStore.token) ? `${process.env.REACT_APP_BACKEND_API}/graphql` :
		`${process.env.REACT_APP_BACKEND_API}/graphqlNoAuth`
})

const wsClient = new SubscriptionClient(`${process.env.REACT_APP_WEBSOCKET_API}/subscriptions`, {
	reconnect: true,
	lazy: true,
	connectionParams: {
		authToken: AuthStore.token
	}
})

// allow subscription io.socket
// const wsLink = new WebSocketLink({
// 	uri: `${process.env.REACT_APP_WEBSOCKET_API}/subscriptions`,
// 	options: {
// 		reconnect: true,
// 		lazy: true,
// 		connectionParams: {
// 			authToken: AuthStore.token
// 		}
// 	},
// })
const wsLink = new WebSocketLink(wsClient)

const link = split(
	({ query }) => {
		const { kind, operation } = getMainDefinition(query)
		return kind === 'OperationDefinition' && operation === 'subscription'
	},
	wsLink,
	uploadLink
)

export const cache = new InMemoryCache({
	dataIdFromObject: object => object.key || null, // avoiding merging of of two seperate data with the same id
	// improving speed performance
	cacheRedirects: {
		// avoid requesting the same data that already in the client that has different key
		Query: {
			// section: (_, args) => toIdValue(cache.config.dataIdFromObject({ __typename: 'Section', uid: args.uid })),
			// students: (_, args) => toIdValue(cache.config.dataIdFromObject({ __typename: 'Student', uid: args.uid })),
			// users: (_, args) => toIdValue(cache.config.dataIdFromObject({ __typename: 'Users', uid: args.uid })),
			// roles: (_, args) => toIdValue(cache.config.dataIdFromObject({ __typename: 'Roles', uid: args.uid })),
			// schoolSettings: (_, args) => toIdValue(cache.config.dataIdFromObject({ __typename: 'Users', uid: args.uid })),
			// profile: (_, args) => toIdValue(cache.config.dataIdFromObject({ __typename: 'Profile', uid: args.uid })),
		},
	},
})

// persistent request when offline until the server is back to online again
// const retry = new RetryLink({ attempts : { max : Infinity } })
// const link_merge = CAN_OFFLINE ?  concat(request, retry, link) : concat(request, link)
// @Note: disable retry until fix the issue
const link_merge = concat(request, link)

// compile apollo client
const client = new ApolloClient({
	link: link_merge,
	cache
})

export default client
